export const QUIZ_TYPE = {
  DAILY: 'daily',
  HALF_TIME: 'half_time'
};

export const QUIZ_ROLE = {
  P4P: 'p4p',
  TEAM: 'team'
};

export const getQuizRole = (user) => {
  if (!user) return null;
  if (user.admin) return QUIZ_ROLE.P4P;
  if (user.type === 'team') return QUIZ_ROLE.TEAM;
  return null;
};

export const canManageHalfTime = (user) => getQuizRole(user) === QUIZ_ROLE.P4P;

export const canManageChannel = (user, teamId) => {
  const role = getQuizRole(user);
  if (role === QUIZ_ROLE.P4P) return true;
  if (role === QUIZ_ROLE.TEAM) return user?._id === teamId;
  return false;
};
